import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognitoTest.userPoolId,
      userPoolClientId: environment.cognitoTest.userPoolClientId,
    }
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
